<template>
  <el-dialog
    :title="isEdit ? '编辑物流公司' : '新增物流公司'"
    :visible.sync="visible"
    width="600px"
    @close="handleClose">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      class="logistics-form">
      <el-form-item label="公司名称" prop="trackName">
        <el-input v-model="form.trackName" placeholder="请输入物流公司名称"></el-input>
      </el-form-item>
      <el-form-item label="公司代码" prop="trackCode">
        <el-input v-model="form.trackCode" placeholder="请输入公司代码"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status" v-if="isEdit">
        <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
          <el-option label="正常" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'LogisticsForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    logisticsData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      submitting: false,
      form: {
        id: undefined,
        trackName: '',
        trackCode: '',
        status: 1
      },
      rules: {
        trackName: [
          { required: true, message: '请输入物流公司名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        trackCode: [
          { required: true, message: '请输入公司代码', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.isEdit) {
        this.form = { ...this.logisticsData }
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: undefined,
        trackName: '',
        trackCode: '',
        status: 1
      }
      this.$refs.form && this.$refs.form.resetFields()
    },
    handleClose() {
      this.resetForm()
      this.$emit('update:visible', false)
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submitting = true
          try {
            if (this.isEdit) {
              const res = await adminApi.updateLogistics(this.form)
              if (res) {
                this.$message.success('更新成功')
                this.handleClose()
                this.$emit('success')
              } else {
                this.$message.error('更新失败')
              }
            } else {
              const res = await adminApi.createLogistics(this.form)
              if (res) {
                this.$message.success('创建成功')
                this.handleClose()
                this.$emit('success')
              } else {
                this.$message.error('创建失败')
              }
            }
          } catch (error) {
            console.error('操作物流公司错误:', error)
            this.$message.error(error.message || '操作失败')
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.logistics-form {
  padding: 20px;
}
</style> 